import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);  // 必须先调用 Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedLibrary: {},
    cookile:'',
  },
  mutations: {
    updateselectedLibrary(state, newMessage) {
      state.selectedLibrary = newMessage;
    },
    updatescookile(state, newMessage) {
        state.cookile = newMessage;
    }
  },
  actions: {
    setMessage({ commit }, newMessage) {
      commit('updateselectedLibrary', newMessage);
    },
    setCookile({ commit }, newMessage) {
        commit('updatescookile', newMessage);
      }
  },
  getters: {
    reversedMessage(state) {
      return state.selectedLibrary.split('').reverse().join('');
    }
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js